<template>
  <div class="gyzhmain">
    <!-- 大图 -->
    <div class="bigbgi">
      <div class="midbgi">
      </div>
    </div>
    <div class="gyzgcont">

      <el-row>
        <el-col :span="5">
          <div class="cdtitle">展商中心</div>
          <el-menu @select="handleSelect" :default-active="pageNum" class="gyzhcd  el-menu-vertical-demo" text-color="#000" active-text-color="#1D50A2">
            <el-menu-item index="1">目标观众</el-menu-item>
            <el-menu-item index="2">展商答疑</el-menu-item>
            <el-menu-item index="3">参展流程</el-menu-item>
            <el-menu-item index="4">资料下载</el-menu-item>
            <el-menu-item index="5">展馆平面图</el-menu-item>
            <el-menu-item index="6" @click="zszpcx">展商展品查询</el-menu-item>
          </el-menu>
          <!-- 相关文章 -->
          <!-- <div>
            <div style="font-size: 24px;color: #2D67B6;letter-spacing: 0;line-height: 22px;font-weight: 600;margin-top:25px;padding-bottom:15px;border-bottom: 3px #1D50A2 solid ;">相关文章</div>
            <div class="xgtitle">关于要求参加第二十二届中国国际关于要求参加第二十二届中国国际关于要求参加第二十二届中国国际</div>
            <div class="address">
              主办单位：中国环境保护产业协会<br />
              地址：北京中国国际展览中心
              （朝阳馆）<br />
              日期：2026年6月2-4日
            </div>
          </div> -->
          <!-- 展出时间 -->
          <div class="zcsj">
            展出时间
          </div>
          <div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                2026年6月2日 9:00-17:00
              </div>
            </div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                2026年6月3日 9:00-17:00
              </div>
            </div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                2026年6月4日 9:00-16:00
              </div>
            </div>
            <div style="margin-bottom:30px" class="rcsj">
              （每日闭馆前1小时停止入场）
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="bread">
            <div>
              <a href="https://www.ciepec-online.com:8086/"> 首页>></a>
            </div>
            <div>展商中心>></div>
            <div>{{menuName}}</div>
          </div>
          <div v-if="menuName=='目标观众'||pageNum==1">
            <img style="width:100%" src="../../assets/index/mbgz.jpg" alt="">
          </div>
          <div style="padding:0 30px" v-if="menuName=='展商答疑'||pageNum==2">
            <img style="width:100%;margin-top:10px" src="../../assets/index/zsdy.jpg" alt="">
            <div style="font-weight:600;font-size: 26px;color: #3d9b35;margin-top:30px;margin-bottom:20px">我们为您列举了参展与参观的常见问题，帮您轻松解答疑惑。</div>
            <div class="question">
              <el-collapse class="collapse" v-model="activeNames">
                <el-collapse-item title="如何申请成为CIEPEC2025（第二十三届中国国际环保展览会）的展商？" name="1">
                  <div>渠道一：意向参展可在展会官网www.ciepec.org首页填写参展意向，主办方将根据报名时间逐个联系；</div>
                  <div>渠道二：意向企业可拨打010-52806519进行咨询</div>
                </el-collapse-item>
                <el-collapse-item title="CIEPEC2024展会时间？" name="2">
                  <div>展览时间：2026年6月2-4日</div>
                </el-collapse-item>
                <el-collapse-item title="CIEPEC2024布展时间？" name="3">
                  <div>特装企业：2026年5月31日-6月1日</div>
                  <div>标准展位：2026年6月1日</div>
                </el-collapse-item>
                <el-collapse-item title="哪里可以下载申请表填写报名？" name="4">
                  <div>请电话咨询主办方。 010-52806519</div>
                </el-collapse-item>
                <el-collapse-item title="最小展位面积是多少？" name="5">
                  <div>标准展位最小面积为3mX3m， 光地展位最小面积为36㎡。</div>
                </el-collapse-item>
                <el-collapse-item title="报名参展的截止日期是什么时候？" name="6">
                  <div>2026年4月30日（售罄则截止）</div>
                </el-collapse-item>
                <el-collapse-item title="是否可以自行寻找搭建公司？" name="7">
                  <div>特装展商可自行寻找搭建公司进行设计搭建。</div>
                </el-collapse-item>
                <el-collapse-item title="运输公司是否有指定企业？" name="8">
                  <div>具体方案将另行公布</div>
                </el-collapse-item>
                <el-collapse-item title="如有其它问题，可以联系谁？" name="9">
                  <div>国外展商咨询：010-52806519-5192/5194</div>
                  <div>国内展商咨询：010-52806519-5193/5195</div>
                  <div>媒体合作、展商宣传咨询：010-52806519-5194</div>
                </el-collapse-item>
              </el-collapse>

            </div>
          </div>
          <div v-if="menuName=='参展流程'||pageNum==3">
            <img style="width:100%; margin:0 40px" src="../../assets/index/czlc.jpg" alt="">
          </div>
          <div style="padding:20px 30px" v-if="menuName=='资料下载'||pageNum==4">
            <div>
              <ul style="overflow: hidden;margin-top: 11px;">
                <li>
                  <a class="xz" href="https://www.ciepec-online.com/u/cms/www/xwy-images/%E5%B1%95%E5%95%86%E6%89%8B%E5%86%8C.pdf" style="    display: block;" target="_blank">
                    <div class="xztit">第二十四届中国国际环保展览会（CIEPEC2026）参展商手册--中文版</div>
                  </a>
                </li>
                <li>
                  <a class="xz" href="https://www.ciepec-online.com/u/cms/www/xwy-images/%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf" style="    display: block;" target="_blank">
                    <div class="xztit">线上平台操作简易步骤</div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div style="padding:0 30px" v-if="menuName=='展馆平面图'||pageNum==5">
            <img height="900px" style="width:100%" src="../../assets/index/zgwz.jpg" alt="">

          </div>

        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Gyzh',
  data () {
    return {
      menuName: '目标观众',
      pageNum: '1',
      activeNames: []
    }
  },
  methods: {
    handleSelect (key) {
      this.menuName = event.target.innerText.trim()
      this.pageNum = key
      // if (this.pageNum == 6) {
      //   window.location.href = 'https://www.ciepec-online.com/'
      // }
    },
    zszpcx () {
      this.$alert('This feature is under maintenance. Please stay tuned!', 'Notice', {
        confirmButtonText: 'OK',
        type: 'info',
        center: true
      })
    }
  }
}
</script>

<style scoped>
.gyzhmain {
  width: 100%;
}
.bigbgi {
  background-image: url('../../assets/home/Header1.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: cover;
  height: 450px; /* 元素高度 */
  width: 100%;
}
.midbgi {
  background-image: url('../../assets/home/renwu.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: 40% 100%;
  height: 450px; /* 元素高度 */
  width: 100%;
}
.gyzgcont {
  width: 80%;
  margin: 0 auto;
}

.gyzhcd {
  background: url('../../assets/index/cebian2.png') no-repeat,
    linear-gradient(180deg, #ffffff 0%, #e4efff 100%);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100%;

  width: 100%;
}
.el-menu-item {
  text-align: center;
  font-size: 18px;
  color: #16181a;
  letter-spacing: -0px;
  text-align: center;
  font-weight: 400;
}
.el-menu-item.is-active {
  font-weight: bold;
  color: #1d50a2;
}
.cdtitle {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -80px;
  height: 86px;
  color: #fff;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
  background-image: url('../../assets/index/cebian1.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: cover;
  height: 80px; /* 元素高度 */
  /* width: 100%; */
}
.bread {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -60px;
  opacity: 0.94;
  background-image: linear-gradient(
    90deg,
    rgba(14, 152, 121, 0) 0%,
    #0e9577 50%
  );
  height: 60px;
  width: 470px;
  float: right;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
}
a {
  text-decoration: none;
  font-size: 16px;
  color: #fff;
}
.address {
  opacity: 0.9;
  background: #eff5ff;
  font-size: 18px;
  color: #333333;
  line-height: 34px;
  font-weight: 400;
  padding: 10px;
}
.zcsj {
  margin: 20px 0;
  padding: 10px 0;
  background: #159a7e;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  font-weight: 600;
}
.rqys {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  height: 40px;
}
.greendian {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background: #159a7e;
}
.rcsj {
  flex: 1;
  font-size: 18px;
  color: #333333;
  text-align: center;
  line-height: 18px;
  font-weight: 400;
}
.xgtitle {
  width: 280px;
  margin-bottom: 10px;
  margin-top: 5px;
  overflow: hidden; /* 确保超出的内容会被裁剪 */
  white-space: nowrap; /* 确保文本在一行内显示 */
  text-overflow: ellipsis; /* 超出的文本部分显示为省略号 */
  font-size: 18px;
  color: #333333;
  line-height: 32px;
  font-weight: 400;
}
.zhzl {
  font-size: 18px;
  font-weight: normal;
  margin: 0 30px;
  line-height: 45px;
}
h2 {
  text-align: center;
}

.dwname {
  font-size: 18px;
  font-weight: normal;
  margin: 0 30px;
  line-height: 25px;
}

/deep/ .el-collapse-item__header {
  font-size: 18px !important;
  border: none;
  background-color: #f6f4f4f3 !important;
  border-radius: 5px;
  padding: 0 10px;
  height: 50px;
}
/deep/ .el-collapse-item {
  margin-bottom: 20px;
}
/deep/ .el-collapse-item__content {
  font-size: 16px;
  padding: 15px 10px 10px 10px;
  line-height: 32px;
  color: grey !important;
}
/deep/ .el-collapse-item__wrap {
  border: none;
}
.el-collapse {
  border: none;
}
.xz {
  text-decoration: none;
  color: #444;
}
.xz:hover {
  color: #55aa5c;
}
.xztit {
  font-size: 18px;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/caidaneng/zszx.vue